import { useMemo } from "react";

import { User } from "@app-types/common.type";
import { IPeople } from "@interfaces/people.interface";

import { MemberListItem } from "./MemberListItem";
import { PersonListItem } from "./PersonListItem";

interface ITeamListProps {
  attendees: User[];
  people: IPeople[];
  erasable?: boolean;
  compactErasable?: boolean;
  size?: "small" | "medium";
  onDelete?: (id: string) => void;
  onClick?: (person: IPeople) => void;
  className?: string;
}
export const TeamList = ({
  attendees,
  people,
  erasable = false,
  compactErasable = false,
  onDelete,
  onClick,
  size = "small",
}: ITeamListProps) => {
  const { suggestedPeople, nonSuggestedPeople } = useMemo(() => {
    const suggestedPeople = people.filter((person) => person.is_suggested);
    const nonSuggestedPeople = people.filter((person) => !person.is_suggested);

    return { suggestedPeople, nonSuggestedPeople };
  }, [people]);

  return (
    <div className="relative flex max-h-[264px] flex-col gap-1 overflow-y-auto overflow-x-hidden px-1">
      {attendees.map((attendee, index) => (
        <MemberListItem
          key={index}
          member={attendee}
          erasable={erasable}
          compactErasable={compactErasable}
          onDelete={() => (onDelete && "id" in attendee ? onDelete(attendee?.id) : null)}
          size={size}
        />
      ))}
      <>
        {nonSuggestedPeople.map((person, index) => (
          <PersonListItem
            key={index}
            size={size}
            person={person}
            erasable={erasable}
            compactErasable={compactErasable}
            onClick={() => (onClick ? onClick(person) : null)}
            onDelete={() => (onDelete ? onDelete(person.id) : null)}
          />
        ))}
        {suggestedPeople.map((person, index) => (
          <PersonListItem
            isSuggested
            key={index}
            size={size}
            person={person}
            erasable={erasable}
            compactErasable={compactErasable}
            onClick={() => (onClick ? onClick(person) : null)}
            onDelete={() => (onDelete ? onDelete(person.id) : null)}
          />
        ))}
      </>
    </div>
  );
};
